module.exports = __webpack_public_path__ + "img/general.b7433878.svg";